const Banner = () => {
  return (
    <div className="banner w-100">
      <img className="w-100" src="./assets/images/banner-image.png" alt="" />
    </div>
  );
};

export default Banner;
